<template>
	<div class="task-link">
		<div class="content">
			<div>Task link</div>
			<div class="link">{{ props.url }}</div>
		</div>

		<ChevronRightIcon class="task-link-icon" />
	</div>
</template>

<script setup lang="ts">
import ChevronRightIcon from '@/assets/icons/chevron-right.svg';

const props = defineProps<{
	url: string;
}>();
</script>

<style scoped>
.task-link {
	box-sizing: border-box;

	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 12px;
	gap: 16px;

	background: linear-gradient(
		83.45deg,
		rgba(2, 122, 255, 0.05) -1.65%,
		rgba(248, 254, 255, 0.05) 52.48%,
		rgba(2, 122, 255, 0.05) 104.15%
	);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 16px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 11px;
	line-height: 13px;

	color: rgba(255, 255, 255, 0.5);

	cursor: pointer;
}

.link {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 15px;
	line-height: 18px;

	color: #ffffff;
}

.content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	padding: 0px;

	flex: none;
	order: 0;
	flex-grow: 1;
}

.task-link-icon {
	width: 16px;
	height: 16px;

	filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

	stroke: #ffffff;
}
</style>
